import List from "@mui/material/List"
import Input from "@mui/material/Input"
import Avatar from "@mui/material/Avatar"
import * as api from '../../../services/api'
import ListItem from "@mui/material/ListItem"
import { useCore } from "../../../hooks/useCore"
import { LooseObject } from "../../../types/core"
import InputLabel from "@mui/material/InputLabel"
import SearchIcon from '@mui/icons-material/Search'
import FormControl from "@mui/material/FormControl"
import ListItemText from "@mui/material/ListItemText"
import { ToastContainer } from 'react-toastify'
import ListItemButton from "@mui/material/ListItemButton"
import InputAdornment from "@mui/material/InputAdornment"
import ListItemAvatar from "@mui/material/ListItemAvatar"
import { Paginator } from "../../../components/Paginator"
import { useEffect, useLayoutEffect, useState } from "react"
import { LoadingPage } from "../../../components/LoadingPage"
import { ListUserProps, UserProps } from "../../../types/user"
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import { useParams, useLocation, useNavigate } from "react-router-dom"
import NoAccountsIcon from '@mui/icons-material/NoAccounts';

export default function Users(): JSX.Element {
  const navigate = useNavigate()
  const location: LooseObject = useLocation()
  let { id } = useParams()

  const { setTitleBar, setPathTitleBar, setPathData } = useCore()

  const [users, setUsers] = useState<UserProps[] | undefined>([])
  const [usersSearch, setUsersSearch] = useState<UserProps[] | undefined>([])
  const [loading, setLoading] = useState<boolean>(true)
  const [count, setCount] = useState<number>(0)
  const [pageNumber, setPageNumber] = useState<number>(1)

  const handleChangePage = async (event: React.ChangeEvent<unknown>, value: number) => {
    setLoading(true)
    setPageNumber(value)
    await getUsers(`user/list/${id}/?page=${value}`)
  }

  const getUsers = async (url: string) => {
    const response = await api.get(url) as ListUserProps
    setCount(response.content.count)
    setUsers(response.content.results)
    setUsersSearch(response.content.results)
    setLoading(false)
  }

  const handleChangeSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
		let value = e.target.value
    search(value)
	}

  function search(value: string) {
    setUsersSearch(
      users?.filter((item) => item.first_name.toLowerCase().indexOf(value.toLowerCase()) > -1 || item.last_name.toLowerCase().indexOf(value.toLowerCase()) > -1 || item.email.toLowerCase().indexOf(value.toLowerCase()) > -1)
    )
  }

  useEffect(() => {
    getUsers(`user/list/${id}/`).catch(console.error)
	}, [id, setUsers, setUsersSearch])

  useLayoutEffect(() => {
    setTitleBar(`Usuários da empresa ${location.state.fantasy_name}`)
    setPathTitleBar(`/new-user/${id}`)
    setPathData({fantasy_name: location.state.fantasy_name})
  }, [id, location.state.fantasy_name, setPathData, setPathTitleBar, setTitleBar])

	return (
		<>
      <ToastContainer />
			{
        !loading
          ? <>
              <List dense disablePadding sx={{ width: '100%' }}>
                <ListItem 
                  key='search' 
                  disablePadding
                >
                  <FormControl fullWidth sx={{ m: 1 }} variant="standard">
                    <InputLabel htmlFor="standard-adornment-amount">Pesquisar</InputLabel>
                    <Input
                      id="input-search"
                      startAdornment={
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      }
                      onChange={handleChangeSearch}
                    />
                  </FormControl>
                </ListItem>

                {usersSearch?.map((item) => (
                    <ListItem
                      key={item.id}
                      disablePadding
                      sx={{
                        opacity: item.is_active ? 1 : 0.6,
                        bgcolor: item.is_active ? 'transparent' : '#f5f5f5',
                        borderRadius: 1
                      }}
                    >
                      <ListItemButton onClick={() => navigate(`/user/${item.id}`)}>
                        <ListItemAvatar>
                          <Avatar>
                            {item.is_active ? <AccountCircleIcon /> : <NoAccountsIcon />}
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary={`${item.first_name} ${item.last_name}`} secondary={item.email} />
                      </ListItemButton>
                    </ListItem>
                  )
                )}
              </List>
              <Paginator count={count} pageNumber={pageNumber} onChange={handleChangePage} />
            </>
        : <LoadingPage />
      }
		</>
	)
}